import { useEffect } from 'react'
import {
  useNavigate,
  useLocation,
  useNavigationType,
  NavigationType,
} from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import { LOGIN_PAGE_PATH, SIGNUP_PAGE_PATH } from 'utils/consts/path'
import { pushPrevLocation, popPrevLocation } from 'store/location'

export const LocationWatcher = () => {
  const location = useLocation()
  const action = useNavigationType()
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(pushPrevLocation(location.pathname))
  }, [])

  useEffect(() => {
    switch (action) {
      case NavigationType.Push:
        dispatch(pushPrevLocation(location.pathname))
        break

      case NavigationType.Pop:
        dispatch(popPrevLocation(location.pathname))
        break

      case NavigationType.Replace:
        dispatch({
          type: 'LOCATION_REPLACE_PREV',
          payload: location.pathname,
        })
        break
    }
  }, [location, action])

  return null
}

const usePrevLocation = () => {
  return useSelector(state => {
    const arr = state.location.prev
    return arr.length > 1 ? arr[arr.length - 2] : null
  })
}

const pathsToExclude = [LOGIN_PAGE_PATH, SIGNUP_PAGE_PATH]

export const useGoBack = ({ fallbackUrl } = {}) => {
  const navigate = useNavigate()
  const prevLocation = usePrevLocation()

  return () => {
    if (prevLocation && !pathsToExclude.includes(prevLocation)) {
      navigate(-1)
      return
    }
    if (fallbackUrl) navigate(fallbackUrl)
  }
}
